<style scoped lang="scss">
@import "../mobile";
//.top-status{
//  background: url("../../../assets/images/mobile/bg_primary.png") no-repeat;
//  background-size: 100% 100%;
//}
.btn-send{
  padding:5px 25px;
  font-weight: bold;
}
</style>
<template>
  <div class="wrap-app bg_gray">
    <qk-back/>
    <qk-status-icon :status="details.webStatus" :statusName="statusName"/>
    <div class="basic">
      <div class="l-title">基本信息</div>
      <ul>
        <li>
          <label>订单号</label>
          <p>{{details.code}}</p>
        </li>
        <li>
          <label>下单时间</label>
          <p>{{details.createTime | rTime}}</p>
        </li>
        <li>
          <label>商品数量</label>
          <p>{{details.quantity}}</p>
        </li>
        <li>
          <label>应付金额</label>
          <p class="text-danger">{{details.amount | amount}}元</p>
        </li>
        <li>
          <label>地址</label>
          <p>{{address}}</p>
        </li>
        <li v-show="details.payRemark">
          <label>备注</label>
          <p>{{details.payRemark}}</p>
        </li>
      </ul>
    </div>
    <div class="detail">
      <ul class="top-tab">
        <li :class="{active: currentTab === index}" v-for="(item, index) in detailsTabs" :key="index" @click="currentTab = index">{{item}}</li>
      </ul>
      <div class="tab-content">
        <div class="tab-panel" v-show="currentTab === 0">
          <div class="molecular-lists">
            <div class="tr"><button class="btn btn-sencond btn-send" v-show="details.retainGoods" @click="$router.push(`/molecular/deliver?id=${id}`)">发货</button></div>
            <div class="molecular-item products-info">
              <ul class="products">
                <li v-for="item in orderLists" :key="item.id">
                  <img :src="item.imgUrl" class="pro-img">
                  <div class="info">
                    <div class="title">
                      {{item.name}}
                      <span class="num">x{{item.needPayQuantity}}</span>
                    </div>
                    <p class="spec mt5">货号：{{item.skuCode}} <span>￥{{item.sku.price | amount}}</span></p>
                    <div class="spec mt5">
                      规格：{{item.spec}}
                      <span class="fz14 text-primary" :class="item.needSendQuantity > 0 ? 'text-danger' : 'text-primary'">{{item.needSendQuantity > 0 ? `剩余数：${item.needSendQuantity}` : '发货完成'}}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="tab-panel" v-show="currentTab === 1">
          <div class="molecular-lists">
            <div class="molecular-item send-info" v-for="item in sendLists" :key="item.id">
              <div class="top">
                <div class="info">
                  <img src="@/assets/images/mobile/icon_user.png" class="icon">
                  <div class="title">配送员/运单号：
                    <div v-if="item.sendType === 'SENDER'">{{item.sender && item.sender.realName}}</div>
                    <div v-else>{{item.deliveryCode}}</div>
                  </div>
                  <p>配送单号：{{item.code}}</p>
                </div>
                <span class="status status-primary">{{item.sendStatusName}}</span>
              </div>
              <ul class="products">
                <li v-for="itx in item.items" :key="itx.id">
                  <img :src="itx.imgUrl" class="pro-img">
                  <div class="info">
                    <div class="title">
                      {{itx.goodsName}}
                      <span class="num">x{{itx.quantity}}</span>
                    </div>
                    <p class="mt5">货号：{{itx.skuCode}}</p>
                    <div class="spec mt5">
                      规格：{{itx.spec}}
                    </div>
                  </div>
                </li>
              </ul>
              <div class="bot">
                更新时间：{{item.lastStatusDate | rTime}}
              </div>
            </div>
          </div>
          <div class="no-data" v-show="sendLists.length === 0">暂无配送记录</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { prodcutOrdersDetail, sendOrders } from '@/services/api.index'
export default {
  data () {
    return {
      detailsTabs: ['产品信息', '配送信息'],
      currentTab: 0,
      id: this.$route.query.id,
      details: {},
      statusName: '',
      orderLists: [],
      sendLists: [],
      address: ''
    }
  },
  created() {
    this.getDetails()
  },
  methods: {
    getDetails () {
      prodcutOrdersDetail(this.id).then(res => {
        const value = res.data.address
        this.address = value.provinceName ? `${value.provinceName}${value.cityName} ${value.streetAddress}` : '-'
        this.statusName = this.baseMethods.molecularOrderStatus(res.data.webStatus)
        this.details = res.data
        this.orderLists = res.data.items
        this.getSendOrders()
      })
    },
    // 配送记录
    getSendOrders () {
      sendOrders(0, 10, this.details.code).then(res => {
        console.log(res.data)
        res.data.map(item => {
          item.sendStatusName = this.baseMethods.sendStatus(item.sendStatus)
        })
        this.sendLists = res.data
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/mobile/molecular/order_details.vue